import React from "react";
import { Link } from "react-router-dom";

import { FiUserCheck, FiFile, VscServer, BiShieldPlus } from '../assets/icons/icons'
 
export default function PricingTwo({bgColor}){
    return(
        <div className="row mt-lg-4 align-items-center">
            <div className="col-lg-5 col-md-12 text-center text-lg-start">
                <div className="section-title mb-4 mb-lg-0 pb-2 pb-lg-0">
                    <h6 className="text-primary">Our Pricing</h6>
                    <h4 className="title mb-4">Comfortable Rates</h4>
                    <p className="text-muted para-desc mx-auto mb-0">Explore and learn more about everything from machine learning and global payments to  scaling your team.</p>
                </div>
            </div>

            <div className="col-lg-7 col-md-12 mt-4 mt-lg-0 pt-2 pt-lg-0">
                <div className="row align-items-center">
                    <div className="col-md-6 col-12">
                        <div className="card pricing border-0 p-4 rounded-md shadow">
                            <div className="card-body p-0">
                                <span className="py-2 px-4 d-inline-block bg-soft-primary h6 mb-0 text-primary rounded-lg">Basic</span>
                                <h1 className="fw-bold mb-0 mt-3">$16.00</h1>
                                <p className="text-muted small">For personal projects</p>

                                <ul className="list-unstyled">
                                    <li className="text-muted mb-0 ms-0"><span className="text-primary h5 me-2"><FiUserCheck /></span>Full Access</li>
                                    <li className="text-muted mb-0 ms-0"><span className="text-primary h5 me-2"><FiFile /></span>Source Files</li>
                                    <li className="text-muted mb-0 ms-0"><span className="text-primary h5 me-2"><VscServer /></span>1 Domain Free</li>
                                </ul>

                                <div className="mt-4">
                                    <div className="d-grid">
                                        <Link to="#" className="btn btn-primary">Create your account</Link>
                                    </div>
                                    <p className="text-muted mt-3 mb-0">*No credit card required</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div className="col-md-6 col-12 mt-4 mt-sm-0 pt-2 pt-sm-0">
                        <div className={bgColor}>
                            <div className="card-body p-0">
                                <span className="py-2 px-4 d-inline-block bg-soft-success h6 mb-0 text-success rounded-lg">Business</span>
                                <h1 className="fw-bold text-white title-dark mb-0 mt-3">$45.00</h1>
                                <p className="text-white-50 small">30-Day free trial</p>

                                <ul className="list-unstyled">
                                    <li className="text-light para-dark mb-0 ms-0"><span className="text-success h5 me-2"><FiUserCheck /></span>Full Access</li>
                                    <li className="text-light para-dark mb-0 ms-0"><span className="text-success h5 me-2"><FiFile /></span>Source Files</li>
                                    <li className="text-light para-dark mb-0 ms-0"><span className="text-success h5 me-2"><VscServer /></span>1 Domain Free</li>
                                    <li className="text-light para-dark mb-0 ms-0"><span className="text-success h5 me-2"><BiShieldPlus /></span>Enhanced Security</li>
                                </ul>

                                <div className="mt-4">
                                    <div className="d-grid">
                                        <Link to="#" className="btn btn-soft-success">Create your account</Link>
                                    </div>
                                    <p className="text-white-50 mt-3 mb-0">*No credit card required</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}